import useTrans from '../../../hooks/useTrans'
import { priceNotation } from '../../../utils/safe'
import { Tooltip } from '../../atoms'
import { Info } from '../../atoms/NewIcons'
import { DettagliProdottoData } from '../DettagliProdotto/DettagliProdotto'

const DettagliProdottoListino = ({ prezzi }) => {
  const t = useTrans()

  return (
    <div className="dettagli-prodotto__listino">
      {prezzi?.tecniche?.map((tecnica, i) => (
        <div className="dettagli-prodotto__listino__block" key={i}>
          <p className="dettagli-prodotto__listino__block-title">
            {tecnica?.nome}
            <span className="consegna-prevista__info">
              <Tooltip
                label={t(
                  'Il prezzo è calcolato in base alla lavorazione consigliata. Non include i costi di avviamento e gestione'
                )}
              >
                <Info />
              </Tooltip>
            </span>
          </p>
          <div className="dettagli-prodotto__listino__table" key={`chunk-${i}`}>
            <div className="dettagli-prodotto__listino__col">
              <p className="dettagli-prodotto__listino__cell dettagli-prodotto__listino__cell--title">
                {t('A partire da')}
              </p>
              <p className="dettagli-prodotto__listino__cell dettagli-prodotto__listino__cell--title">
                {t('Prezzo stampa')}
              </p>
            </div>

            {tecnica.posizioni?.[0]?.numero_colori?.[0]?.personalizzazioni_objects?.[0]?.prezzi_personalizzazione.map(
              (obj, j) => {
                return (
                  <div key={j} className="dettagli-prodotto__listino__col">
                    <div className="dettagli-prodotto__listino__cell dettagli-prodotto__listino__cell--quantity">
                      {obj.a_partire_da}
                    </div>
                    <div className="dettagli-prodotto__listino__cell">
                      {priceNotation(obj.prezzo, 3)} €
                    </div>
                  </div>
                )
              }
            )}
          </div>
          {!!tecnica.costo_impianto && (
            <DettagliProdottoData
              label={t('Impianto')}
              value={`${priceNotation(tecnica.costo_impianto, 2)} € ${
                !tecnica.posizioni?.[0]?.numero_colori?.[0]?.full_color ? `${t('per colore')}` : ''
              }`}
              className="dettagli-prodotto__listino__impianto"
            />
          )}
        </div>
      ))}
    </div>
  )
}

export default DettagliProdottoListino
